import { Component, inject, input, output, signal } from '@angular/core';
import { TimelineChartLegendItem } from '../../models/timeline-chart-input.interface';
import { TimelineChartService } from '../../service/timeline-chart.service';

@Component({
  selector: 'pozi-timeline-chart-legend',
  imports: [],
  templateUrl: './timeline-chart-legend.component.html',
  styleUrl: './timeline-chart-legend.component.scss',
})
export class TimelineChartLegendComponent {
  private timelineChartService = inject(TimelineChartService);

  legendItems = input.required<TimelineChartLegendItem[]>();
  hiddenTimelineKeys = input<string[]>([]);
  hiddenAmChartSeriesKeys = input<string[]>([]);
  isAllItemsHidden = input<boolean>(false);

  highlightedLegendItemIndex = signal<number | null>(null);

  legendItemMouseEnter = output<TimelineChartLegendItem>();
  legendItemMouseLeave = output<TimelineChartLegendItem>();
  legendItemClick = output<TimelineChartLegendItem>();

  /**
   * Determines if a legend item is hidden based on the hidden timeline and series keys.
   *
   * @param item - The legend item to check.
   * @returns `true` if the item is hidden; otherwise, `false`.
   */
  isLegendItemHidden(item: TimelineChartLegendItem): boolean {
    return this.timelineChartService.isLegendItemHidden(
      item,
      this.hiddenTimelineKeys(),
      this.hiddenAmChartSeriesKeys()
    );
  }
}
